var _path, _g, _circle, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoveIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 295,
    viewBox: "0 0 376 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.927 80.416C57.0387 35.4318 142.587 51.9833 210.843 59.7267C267.124 66.1116 334.351 75.0935 356.429 116.662C378.291 157.824 329.275 184.089 288.414 205.777C241.846 230.495 189.781 264.413 132.17 235.695C60.9145 200.176 13.7805 132.188 36.927 80.416Z",
    fill: "#E7E2EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_1800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.823 203H63.8232V124.45L123.821 76L183.823 124.45V203Z",
    fill: "#D7CDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.705 144.644V56.4932H192.026H135.837V128.006H97.9062V221.586H217.634H307.116V144.644H275.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M238.437 144.644H217.635V221.586H238.437V144.644Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8398 221.586H321.423",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.706 56.4932H192.026V128.006H217.635V144.644H275.706V56.4932Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.026 56.4932H135.838V128.006H192.026V56.4932Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.634 128.006H97.9062V221.586H217.634V128.006Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.755 128.006V221.586",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.635 221.586H307.117V144.644H217.635",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.142 202.766L195.252 205.265V221.586H203.142V202.766Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88 83.6281L159.989 81.1333V56.4932H167.88V83.6281Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.368 161.02V173.915",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.517 163.482L291.931 161.116C291.778 160.976 291.578 160.898 291.371 160.898C291.164 160.898 290.964 160.976 290.811 161.116L288.221 163.482",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94 161.02V173.915",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.089 163.483L279.498 161.116C279.346 160.977 279.147 160.899 278.941 160.899C278.735 160.899 278.536 160.977 278.384 161.116L275.793 163.483",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08 138.407H145.35C143.518 138.407 142.033 139.897 142.033 141.736V151.068C142.033 152.907 143.518 154.398 145.35 154.398H167.08C168.912 154.398 170.397 152.907 170.397 151.068V141.736C170.397 139.897 168.912 138.407 167.08 138.407Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M230.149 132.165H217.635V144.643H230.149V132.165Z",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 55,
    r: 32,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3992 64V61.582C57.5086 60.6633 58.5832 59.7533 59.6232 58.852C60.6806 57.9507 61.6166 57.058 62.4312 56.174C63.2632 55.29 63.9219 54.432 64.4072 53.6C64.9099 52.7507 65.1612 51.9273 65.1612 51.13C65.1612 50.3847 64.9532 49.726 64.5372 49.154C64.1386 48.582 63.4712 48.296 62.5352 48.296C61.5819 48.296 60.8626 48.608 60.3772 49.232C59.8919 49.856 59.6492 50.61 59.6492 51.494H56.4252C56.4599 50.1593 56.7546 49.05 57.3092 48.166C57.8639 47.2647 58.6006 46.5973 59.5192 46.164C60.4379 45.7133 61.4692 45.488 62.6132 45.488C64.4679 45.488 65.9066 45.9993 66.9292 47.022C67.9692 48.0273 68.4892 49.336 68.4892 50.948C68.4892 51.9533 68.2552 52.9327 67.7872 53.886C67.3366 54.8393 66.7386 55.758 65.9932 56.642C65.2479 57.526 64.4419 58.358 63.5752 59.138C62.7086 59.9007 61.8679 60.6113 61.0532 61.27H68.9312V64H56.3992Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_1800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 166,
    fill: "white",
    transform: "translate(48.8232 56)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIn);
export default __webpack_public_path__ + "static/media/MoveIn.9bbe9b02c7f7f36d227fcc3677414947.svg";
export { ForwardRef as ReactComponent };